import { useDataMapping } from "./DataMappingContext";

export function useSession() {
  const { state, dispatch } = useDataMapping();
  return {
    ...state.session,
    // `info` is the raw session response (snake_case), so the authoritative questionnaire and target
    // come from the server rather than from the URL the user happens to be on.
    setSession: (id, status, info = {}) =>
      dispatch({
        slice: "session",
        type: "SET_SESSION",
        id,
        status,
        questionnaireId: info.questionnaire_id ?? null,
        aiIngestTarget: info.ai_ingest_target ?? null,
        hasTaskTemplate: info.has_task_template ?? false,
        sessionKind: info.session_kind ?? "questionnaire",
        foundationYearId: info.foundation_year_id ?? null,
      }),
    setFile: (hasFile, name) => dispatch({ slice: "session", type: "SET_FILE", hasFile, name }),
    setStatus: (status) => dispatch({ slice: "session", type: "SET_STATUS", status }),
  };
}
